export const TABLE_HEAD_TAGS = [
  { id: 'id', name: 'id', label: 'tag.id', alignRight: false },
  {
    id: 'name',
    name: 'name',
    label: 'tag.name',
    alignRight: false,
  },
  {
    id: 'description',
    name: 'description',
    label: 'tag.description',
    alignRight: false,
  },
  {
    id: 'department.name',
    name: 'department',
    label: 'tag.department',
    alignCenter: true,
  },
  {
    id: 'createdBy.username',
    name: 'createdBy',
    label: 'tag.createdBy',
    alignCenter: true,
  },
  {
    id: 'createdAt',
    name: 'createdAt',
    label: 'tag.createdAt',
    alignCenter: true,
  },
  {
    id: 'updatedAt',
    name: 'updatedAt',
    label: 'tag.updatedAt',
    alignCenter: true,
  },
  { id: 'actions', name: 'actions', label: 'tag.actions', sticky: true },
];
